app.controller("featuresController", [
    "$scope",
    "$location",
    "$timeout",
    "$uibModal",
    "countryConfig",
    function ($scope, $location, $timeout, $uibModal, countryConfig) {
        $scope.controllerName = "featuresController";
        $scope.countryConfig = countryConfig;

        $scope.$on('$viewContentLoaded', function (event) {
            $timeout(function () {
                var sectionId = $location.hash();
                if (sectionId) {
                    var element = document.getElementById(sectionId);
                    if (element) {
                        window.scrollTo({
                            top: element.getBoundingClientRect().top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                }
            },  0);
        });

        $scope.openDemoModal = function (planName) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/src/website/book-demo.modal.html',
                controller: 'bookDemoController',
                backdropClass: 'modern-modal-backdrop',
                windowClass: 'modern-modal-window',
                size: 'md',
                resolve: {
                    selectedPlan: function () {
                        return planName;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                console.log('Modal closed with result:', result);
            }, function (reason) {
                console.log('Modal dismissed:', reason);
            });
        };
    }
]);
